<template>
  <div class="design-quality-details">
    <div class="w ql-editor">
      <div v-html="content" class="content-html"></div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
export default {
  name: "AboutUs",
  components: {},
  data() {
    return {
      content: ""
    };
  },
  mounted() {
    this.search();
  },
  watch: {},
  methods: {
    // 查询
    search() {
      this.$http.get(`about/aboutMe`).then(res => {
        if (res.data.code == "success") {
          this.content = res.data.data.remark;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.design-quality-details {
  min-height: 88vh;
  background: #f2f2f2;
  margin: 40px 0;
  .content-html {
    line-height: 2;
  }
}
</style>
